import styles from "./creatorFitIntro.module.scss";

const STEPS = [
  { label: "Set criteria", hint: "What “good fit” means for this campaign" },
  { label: "Add creators", hint: "One handle, or a sheet of many" },
  { label: "Review scores", hint: "Shortlist, pass, or rerun" },
];

export function CreatorFitIntro({ current }: { current: 1 | 2 | 3 }) {
  return (
    <div className={styles.intro}>
      <p className={styles.kicker}>Plan</p>
      <h2 className={styles.introTitle}>Creator Fit</h2>
      <p className={styles.introSubtitle}>
        Score creators against one shared rubric — then shortlist before outreach.
      </p>
      <ol className={styles.progress}>
        {STEPS.map((step, index) => {
          const number = index + 1;
          const isCurrent = current === number;
          const isDone = number < current;
          return (
            <li key={step.label} className={styles.progressItem}>
              {index > 0 ? (
                <span
                  className={`${styles.progressLine} ${
                    isDone || isCurrent ? styles.progressLineActive : ""
                  }`}
                />
              ) : null}
              <div className={styles.progressMark}>
                <span
                  className={`${styles.progressBadge} ${
                    isCurrent ? styles.progressBadgeCurrent : ""
                  } ${isDone ? styles.progressBadgeDone : ""}`}
                >
                  {number}
                </span>
                <p
                  className={`${styles.progressLabel} ${
                    isCurrent ? styles.progressLabelCurrent : ""
                  }`}
                >
                  {step.label}
                </p>
              </div>
              {index < STEPS.length - 1 ? (
                <span
                  className={`${styles.progressLine} ${
                    isDone ? styles.progressLineActive : ""
                  }`}
                />
              ) : null}
            </li>
          );
        })}
      </ol>
      <p className={styles.progressHint}>{STEPS[current - 1]?.hint}</p>
    </div>
  );
}
